
































import Vue from "vue";
import Component from "vue-class-component";
import ManageUsersDialog from "../dialogs/ManageUsersDialog.vue"
import ChangePasswordDialog from "@/components/layout/dialogs/ChangePasswordDialog.vue";
import { user, auth } from "@/store";

@Component({
  components: {
    ManageUsersDialog,
    ChangePasswordDialog,
  },
})
export default class UserMenu extends Vue {
  get userName() {
    return user.getters.userName;
  }

  get fullName() {
    return user.getters.fullName;
  }

  get isAdmin() {
    return user.getters.isAdmin;
  }

  logout() {
    auth.dispatch("authLogout");
  }
}
